import 'react-app-polyfill/ie11'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import AppProviders from './AppProviders'
import * as serviceWorker from './serviceWorker'

ReactDOM.createRoot(document.getElementById('root')).render(
  <AppProviders>
    <App />
  </AppProviders>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
